import { render, staticRenderFns } from "./CurtainTreePassport.vue?vue&type=template&id=6f58fb0c&scoped=true"
import script from "./CurtainTreePassport.vue?vue&type=script&lang=js"
export * from "./CurtainTreePassport.vue?vue&type=script&lang=js"
import style0 from "./CurtainTreePassport.vue?vue&type=style&index=0&id=6f58fb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58fb0c",
  null
  
)

export default component.exports